import GNB from '../GNB'
import {
  MENU_HOME,
  MENU_VOD,
  MENU_LIVE,
  MENU_MOVIE,
  MENU_PLAYY,
  MENU_TV_CUT,
  MENU_GLOBAL,
  MENU_MY,
  MENU_CATEGORY
} from '../menu/menu.const'
import { get, filter, head } from 'lodash'
import { getEventListByType } from './event.util'
import { MENU_MOVIE_17 } from '@/common/menu/menu.const'
// import EventModelClass from '@/common/model/EventModelClass'

export const getGnbList = () => {
  return get(GNB, 'gnblist', [])
}

export const mapPathToUICode = (path) => {
  switch (path) {
    case MENU_HOME:
      return 'GN51'
    case MENU_VOD :
      return 'GN2'
    case MENU_LIVE :
      return 'GN54'
    case MENU_MOVIE :
      return 'GN16'
    case MENU_MOVIE_17 :
      return 'GN17'
    case MENU_PLAYY :
      return 'GN5'
    case MENU_TV_CUT :
      return 'GN6'
    case MENU_GLOBAL :
      return 'GN12'
    case MENU_MY :
      return 'GN53'
    case MENU_CATEGORY :
      return 'GN52'
  }
}

function getTargetGnb (uiCode) {
  return head(filter(getGnbList(), (gnbObject) => {
    return get(gnbObject, 'uicode', '') === uiCode
  }))
}

export const getGNBMultiBannerEventListByUICode = (uiCode) => {
  const targetGNB = getTargetGnb(uiCode)
  return getEventListByType(targetGNB.eventlist)
}
